import { useState, useEffect, useContext } from "react";
import { SocketContext } from "../../context/socket";
import CustomLeaderboardPreview from "../../routes/viewers/CustomLeaderboardPreview";

export default function CustomLeaderboardPreviewWrapper({ leaderboardId, params, currentPage = 0, onPreviewDataUpdate }) {
   const socket = useContext(SocketContext);
   const [activeData, setActiveData] = useState(null);
   const [show, setShow] = useState(true);

   useEffect(() => {
      if (leaderboardId) {
         // Parse params if provided
         let parsedParams = {};
         if (params) {
            try {
               parsedParams = typeof params === 'string' ? JSON.parse(params) : params;
            } catch (error) {
               console.error("Error parsing params:", error);
            }
         }

         // Get roundId override from params, default to undefined to use leaderboard's StandingsId
         const roundIdOverride = parsedParams.roundId !== undefined ? parsedParams.roundId : undefined;

         // Call getCustomLeaderboard with roundId override to reload data with correct round
         socket.emit("getCustomLeaderboard", leaderboardId, roundIdOverride, (response) => {
            if (response) {
               // Override with params if provided
               const updatedData = {
                  ...response,
                  Columns: parsedParams.columns !== undefined ? parsedParams.columns : (response.Columns || 1),
                  Rows: parsedParams.rows !== undefined ? parsedParams.rows : (response.Rows || 8),
                  Archetype: parsedParams.archetype !== undefined ? parsedParams.archetype : (response.Archetype || 0),
                  showSubtitle: parsedParams.showSubtitle !== undefined ? parsedParams.showSubtitle : true,
                  customSubtitle: parsedParams.customSubtitle !== undefined ? parsedParams.customSubtitle : "",
               };

               // Update StandingsId if roundId was provided
               if (parsedParams.roundId !== undefined) {
                  updatedData.StandingsId = parsedParams.roundId;
               }

               // Handle round name display
               if (parsedParams.roundId === 0) {
                  // Most Recent - use round name from first row of standings data
                  updatedData.Round = response.Round || "Most Recent";
                  updatedData.showRoundInOrange = true;
                  setActiveData(updatedData);
               } else if (parsedParams.roundId === 9999999 || parsedParams.roundId === '9999999') {
                  // Round 0 (Alphabetical) - no round subtitle
                  updatedData.Round = undefined;
                  updatedData.StandingsId = undefined;
                  setActiveData(updatedData);
               } else if (parsedParams.roundId !== undefined) {
                  // Specific round - use round name from response (which comes from standings data)
                  updatedData.Round = response.Round || "";
                  updatedData.showRoundInOrange = true;
                  setActiveData(updatedData);
               } else {
                  // No round override - use response as-is
                  if (response.StandingsId && response.StandingsId > 0 && response.Round) {
                     updatedData.showRoundInOrange = true;
                  }
                  setActiveData(updatedData);
               }
            }
         });
      }
   }, [leaderboardId, params]);

   // Expose activeData to parent via callback
   useEffect(() => {
      if (onPreviewDataUpdate && activeData) {
         onPreviewDataUpdate(activeData);
      }
   }, [activeData, onPreviewDataUpdate]);

   if (!activeData) {
      return null;
   }

   return (
      <CustomLeaderboardPreview
         currentPage={currentPage}
         activeData={activeData}
         show={show}
         preview={true}
      />
   );
}
